import { render } from "./PortraitOverlay.vue?vue&type=template&id=20adf171&scoped=true"
import script from "./PortraitOverlay.vue?vue&type=script&lang=js"
export * from "./PortraitOverlay.vue?vue&type=script&lang=js"

import "./PortraitOverlay.vue?vue&type=style&index=0&id=20adf171&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20adf171"]])

export default __exports__